import {
  getAdminSettings,
  getSuperUserLoginForm,
  getSuperUserPasswordSetter,
} from '@lmt/unicorn-shared/app/components/DesktopUI';
import { isElectron } from '@lmt/unicorn-shared/app/helpers/common';
import { getBridge } from 'lmt-patientmanager/utils/bridge';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { pages } from '../constants/sharedRoutes';
import { LoginForm } from './login-form/LoginForm';
import { CreateTenant } from './tenants/create/CreateTenant';
import { Modal } from './common';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import { useEventCallback } from '@mui/material';

const WelcomePage: React.FunctionComponent = React.memo(function HomePage() {
  const navigate = useNavigate();
  const i18next = useScopedTranslation('home');
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'light');
  }, []);

  const AdminSettings = getAdminSettings();
  const SuperUserPasswordSetter = getSuperUserPasswordSetter();
  const SuperUserLoginForm = getSuperUserLoginForm();
  const createTenantUrlMatch = pages.createTenant.useMatch();

  const [isServerSettingsOpen, setServerSettingsOpen] = useState(false);

  const [isSuperUserNeedSetting, setIsSuperUserNeedSetting] = useState(false);

  const [isSuperUserPasswordSetterOpen, setSuperUserPasswordSetterOpen] =
    useState(isSuperUserNeedSetting && !!SuperUserPasswordSetter);
  const [isSuperUserLoginOpen, setSuperUserLoginOpen] = useState(false);

  useEffect(() => {
    if (isElectron()) {
      const bridge = getBridge();
      bridge
        .getSuperUserSettings()
        .then((x) => {
          const superUserNeedSetting = !x.passwordHash && !x.password;
          const superUserPasswordSetterOpen =
            superUserNeedSetting && !!SuperUserPasswordSetter;

          setIsSuperUserNeedSetting(superUserNeedSetting);
          setSuperUserPasswordSetterOpen(superUserPasswordSetterOpen);
        })
        .catch((e) => console.error('getSuperUserSettings', e));
    }
  }, []);

  const closeCreate = useEventCallback(() => navigate(pages.home.link()));

  const onSettingsIconClick = useEventCallback(() => {
    setSuperUserLoginOpen(true);
  });

  return (
    <>
      <LoginForm
        onSettingsIconClick={
          isSuperUserNeedSetting ? undefined : onSettingsIconClick // do not open settings if superuser is not set
        }
      />
      {isSuperUserPasswordSetterOpen && (
        <Modal
          isOpen
          contentLabel={i18next.t('super_user_settings')}
          onRequestClose={() => setSuperUserPasswordSetterOpen(false)}
        >
          <SuperUserPasswordSetter
            onSuccess={() => {
              setSuperUserPasswordSetterOpen(false);
              setIsSuperUserNeedSetting(false);
            }}
          />
        </Modal>
      )}
      {isSuperUserLoginOpen && (
        <Modal
          isOpen
          contentLabel={i18next.t('super_user_login')}
          onRequestClose={() => setSuperUserLoginOpen(false)}
        >
          <SuperUserLoginForm
            onSuccess={() => {
              setSuperUserLoginOpen(false);
              setServerSettingsOpen(true);
            }}
          />
        </Modal>
      )}
      {isServerSettingsOpen && (
        <Modal
          contentLabel={i18next.t('admin_settings')}
          isOpen
          onRequestClose={() => setServerSettingsOpen(false)}
        >
          <AdminSettings />
        </Modal>
      )}
      {createTenantUrlMatch && (
        <Modal
          contentLabel={i18next.t('create_tenant')}
          isOpen
          onRequestClose={closeCreate}
        >
          <CreateTenant />
        </Modal>
      )}
    </>
  );
});
export default WelcomePage;
